import * as React from 'react'

import DesktopListTable from '~/client/src/desktop/tables/DesktopListTable'
import ListBandHeader from '~/client/src/desktop/tables/ListBandHeader'
import type { UseTableListResult } from '~/client/src/desktop/tables/useTableList'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import type { IResourceFormRow } from './types'

interface IProps {
  readonly list: UseTableListResult<IResourceFormRow>
  readonly onEdit: (id: string) => void
}

export default function ResourceFormsTable({
  list,
  onEdit,
}: IProps): React.ReactElement {
  return (
    <DesktopListTable
      list={list}
      ariaLabel={Localization.translator.forms}
      fillContainerWidth
      onActivate={record => onEdit(record.id)}
      renderBand={band => <ListBandHeader band={band} width="full" />}
    />
  )
}
